import MarcaUpdate from './MarcaUpdate'
export {MarcaUpdate}
export default MarcaUpdate
